import { render, staticRenderFns } from "./message-details-from-block.vue?vue&type=template&id=ae2995cc&scoped=true&"
import script from "./message-details-from-block.vue?vue&type=script&lang=js&"
export * from "./message-details-from-block.vue?vue&type=script&lang=js&"
import style0 from "./message-details-from-block.vue?vue&type=style&index=0&id=ae2995cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2995cc",
  null
  
)

export default component.exports